<div>
    @if (showEditMode) {
        <cerrix-textarea
            [(ngModel)]="value"
            [placeholder]="placeholder"
            (blurEvent)="onBlur()"
            [autoGrowEnabled]="true"
            [required]="required"
            #cerrixInput
        ></cerrix-textarea>
    } @else {
        @if (value) {
            <div class="{{ showFullText ? 'full-text' : 'readonly-text' }} " [title]="value">
                {{ value }}
            </div>
        } @else {
            <div class="readonly-text">
                {{ noValuePlaceholder }}
            </div>
        }
        @if (!disabled) {
            <div class="edit-text-button" (click)="enableEditMode()">
                <span>{{ editButtonText }}</span>
                <i class="fal fa-edit"></i>
            </div>
        }
    }
</div>
